import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '../../context/AuthContext';
import { getStoredToken } from '../../utils/authStorage';

export default function AuthGuard({ children }: { children: React.ReactNode }) {
    const navigate = useNavigate();
    const { isAuthenticated, isLoading } = useAuth();

    useEffect(() => {
        const token = getStoredToken();

        if (!token) {
            navigate('/signin', { replace: true });
            return;
        }

        if (!isLoading && !isAuthenticated) {
            navigate('/signin', { replace: true });
        }
    }, [isAuthenticated, isLoading, navigate]);

    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-500 mx-auto mb-4"></div>
                    <p className="text-gray-600 dark:text-gray-400">Loading...</p>
                </div>
            </div>
        );
    }

    const token = getStoredToken();
    if (!token || !isAuthenticated) {
        return null;
    }

    return <>{children}</>;
}
